import {toIcon} from "./icon.shared";

export const minus = toIcon(
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.25 8.25H9.75H14.25V9.75H9.75H8.25H3.75V8.25H8.25Z" fill="#216E05" />
  </svg>,
);
